import { useCallback, useMemo } from 'react';

import { Image } from '@/shared/ui';

interface Props {
  expectedPath?: string;
  className?: string;
  disabled?: boolean;
}

export const AUTH_CHECKSUM_SEARCH_PARAM_NAME = 'auth_checksum';

export const IdGovProvider: React.FC<Props> = ({ expectedPath = '', disabled = true, className = '' }) => {
  const idgovUrl = useMemo<string>(
    () =>
      `${import.meta.env.VITE_IDGOV_REDIRECTURI}?${
        expectedPath
          ? new URLSearchParams({
              next_page: expectedPath,
            }).toString()
          : ''
      }`,
    [expectedPath],
  );

  const onIdgovAuth = useCallback(() => {
    window.open(idgovUrl, '_self');
  }, [idgovUrl]);

  return (
    <button className={className} onClick={onIdgovAuth} disabled={disabled}>
      <Image src="/images/id-gov-ua-black.svg" alt="id gov ua" width={125} height={48} />
    </button>
  );
};
